import pathField from '@/helpers/pathField';
import globalNewCar from "../../helpers/globalNewCar";
import getBaseUrl from "../../helpers/getBaseUrl";
import router from '@/router';
import getters from './getters';

export default {
    SET_DATA(state, {field, data}) {
        // state[field] = data
        pathField(state, field, data)
    },
    SET_CAR: (state, payload) => {
        const imageUrl = getBaseUrl();
        let car = payload;
        const q = window.location.search;

        if (router.currentRoute.name != "PriceList") {
            if (!getters.flagCarInStock && car.status == 2) {
                router.push('/kjarabilar/' + car.id + q);
            }

            if (getters.flagCarInStock && car.status == 1) {
                let url = router.resolve({name: 'DealersCars', params: {id: car.id}});
                url = url.href + "/" + car.id + q;

                if (url != router.currentRoute.fullPath) {
                    router.push(url);
                }
            }
        }

        car.big_photo
            ? (car.big_photo = globalNewCar.getPicUrl(car.big_photo))
            : (car.big_photo = `${imageUrl}/img/bilasolur-thumb2.jpg`);

        car.thumbnail
            ? (car.thumbnail = globalNewCar.getPicUrl(car.thumbnail))
            : (car.thumbnail = `${imageUrl}/img/bilasolur-thumb2.jpg`);

        // car.brand_id = car.brand;
        car.brand = car.brand.capitalize();


        let sl = car.sl;
        for (let k in sl) {
            !sl[k].thumbnail
                ? (sl[k].thumbnail = `${imageUrl}/img/bilaumbod-front-page.png`)
                : // : (sl[k].thumbnail =  `${imageUrl}/img/new_cars/jpg/` + sl[k].thumbnail);
                (sl[k].thumbnail = globalNewCar.getPicUrl(sl[k].thumbnail));
        }


        const imgObj = new Image();
        imgObj.src = car.big_photo;
        imgObj.onload = () => {
            state.dataCarLoadedFlag = true;
        };
        imgObj.onerror = () => {
            car.big_photo = `${imageUrl}/img/bilaumbod-front-page.png`;
            state.dataCarLoadedFlag = true;
        };

        state.newCar = car;
    },
    setCurBanner(state,val){
        state.curBanner = val;
    },
    setResCars(state,val){
        state.resCars = val;
    }

}